/**
 * Princípios da filosofia Lean Startup
 */

export const philosophyPrinciples = [
  {
    id: 'principle-1',
    titleKey: 'philosophyPrinciples.0.title',
    descriptionKey: 'philosophyPrinciples.0.description',
  },
  {
    id: 'principle-2',
    titleKey: 'philosophyPrinciples.1.title',
    descriptionKey: 'philosophyPrinciples.1.description',
  },
  {
    id: 'principle-3',
    titleKey: 'philosophyPrinciples.2.title',
    descriptionKey: 'philosophyPrinciples.2.description',
  },
  {
    id: 'principle-4',
    titleKey: 'philosophyPrinciples.3.title',
    descriptionKey: 'philosophyPrinciples.3.description',
  },
];

export default philosophyPrinciples;
